import _ from 'underscore';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'recent-survey-response',

    events: {
        'click' : 'onOpen'
    },

    dom_handlers: {
        onOpen: function(e) {
            Modals.openSurveyResponse(this.model, this.user_data, this.model_list);
        }
    },

    initialize: function(options) {
        this.user_data  = options.user_data;
        this.model_list = options.model_list;
    },

    render: function() {
        var project_name = Cache.project.get(this.model.get('project_id')).escape('name') || '';

        var total = 0;
        var answered = 0;

        _.each(this.model.get('answers'), (answer) => {
            total++;

            if (answer !== '') {
                answered++;
            }
        });

        var content =
        '<div class="flex-between">' +
            '<div class="text-info text-medium font-weight-medium">' + project_name + '</div>' +
            '<div class="text-info text-medium">' + Util.moment(this.model.get('create_time')) + '</div>' +
        '</div>' +
        '<div class="text-default font-weight-medium ellipsis margin-top-8">' + answered + ' of ' + total + ' answered</div>';

        this.$el.html(content);

        return this;
    }
});